import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/itunes': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8 394.8 346.1 394.8 251.6C394.8 157 318.1 80.3 223.6 80.3zM303 320.3C299.8 333.9 289.5 341.5 275.7 344.1 263.6 346.3 253.5 346.9 243.8 339.1 232 329.1 231.8 312.7 242.4 302.3 250.8 294.3 262.7 292.7 280.4 289.5 283.4 289 286 288.3 288.1 285.8 291.3 282.2 290.3 283.8 290.3 205 290.3 199.4 287.6 197.9 281.9 198.9 277.9 199.6 190 216 190 216 185 217.1 183.3 218.6 183.3 224.3 183.3 340.4 183.8 335.1 182.1 342.8 180 351.8 174.5 358.6 167.2 362.4 158.9 367 143.8 369 135.8 367.6 114.4 363.6 106.9 338.9 121.4 324.7 129.8 316.7 141.7 315.1 159.4 311.9 162.4 311.4 165 310.7 167.1 308.2 172.1 302.5 168 181.2 169.7 174.5 170.1 171.9 171.2 169.7 173.2 168.1 175.3 166.4 179 165.4 179.9 165.4 280.9 146.4 293.2 144 295 144 300.7 143.6 304 147 304 152.7 303.9 323.3 304.4 314.1 303 320.3zM345.2 32H102.8C45.9 32 0 77.9 0 134.8V377.2C0 434.1 45.9 480 102.8 480H345.2C402.2 480 448 434.1 448 377.2V134.8C448 77.9 402.1 32 345.2 32zM223.6 444C117.3 444 31.1 357.8 31.1 251.5S117.3 59 223.6 59 416.1 145.2 416.1 251.5 329.9 444 223.6 444z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/itunes.js
// module id = O75T
// module chunks = 144